import { z } from 'zod';

import { PayPeriodDtoSchema } from '../pay-periods/index.js';
import { WeekStartsOnSchema } from '../time-tracking/time-tracking-settings.schema.js';
import type {
  GetWeeklyMyTimeReportRequest,
  GetWeeklyMyTimeReportResponse,
  GetWeeklyTeamTimeReportRequest,
  GetWeeklyTeamTimeReportResponse,
  ListRecentPayPeriodsForReportsRequest,
  ListRecentPayPeriodsForReportsResponse,
  WeeklyTimeReportDailyBreakdownItemDto,
  WeeklyTimeReportItemDto,
  WeeklyTimeReportSettingsDto,
} from './time-tracking-reports.dto.js';

const LocalDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected localDate in YYYY-MM-DD format');

export const WeeklyTimeReportDailyBreakdownItemDtoSchema: z.ZodType<WeeklyTimeReportDailyBreakdownItemDto> =
  z.object({
    localDate: LocalDateSchema,
    minutes: z.number().int().nonnegative(),
  });

export const WeeklyTimeReportItemDtoSchema: z.ZodType<WeeklyTimeReportItemDto> = z.object({
  employeeId: z.uuid(),
  employeeDisplayName: z.string().min(1),
  totalMinutes: z.number().int().nonnegative(),
  regularMinutes: z.number().int().nonnegative(),
  overtimeMinutes: z.number().int().nonnegative(),
  dailyBreakdown: z.array(WeeklyTimeReportDailyBreakdownItemDtoSchema).optional(),
});

export const WeeklyTimeReportSettingsDtoSchema: z.ZodType<WeeklyTimeReportSettingsDto> = z.object({
  timezone: z.string().min(1),
  weekStartsOn: WeekStartsOnSchema,
  overtimeThresholdMinutesPerWeek: z.number().int().positive(),
});

export const GetWeeklyTeamTimeReportRequestSchema: z.ZodType<GetWeeklyTeamTimeReportRequest> = z.object({
  companyId: z.uuid(),
  payPeriodId: z.uuid(),
});

export const GetWeeklyTeamTimeReportResponseSchema: z.ZodType<GetWeeklyTeamTimeReportResponse> = z.object({
  payPeriod: PayPeriodDtoSchema,
  settings: WeeklyTimeReportSettingsDtoSchema,
  items: z.array(WeeklyTimeReportItemDtoSchema),
});

export const GetWeeklyMyTimeReportRequestSchema: z.ZodType<GetWeeklyMyTimeReportRequest> = z.object({
  companyId: z.uuid(),
  payPeriodId: z.uuid().optional(),
});

export const GetWeeklyMyTimeReportResponseSchema: z.ZodType<GetWeeklyMyTimeReportResponse> = z.object({
  payPeriod: PayPeriodDtoSchema,
  settings: WeeklyTimeReportSettingsDtoSchema,
  employee: WeeklyTimeReportItemDtoSchema,
});

export const ListRecentPayPeriodsForReportsRequestSchema: z.ZodType<ListRecentPayPeriodsForReportsRequest> =
  z.object({
    companyId: z.uuid(),
    limit: z.coerce.number().int().min(1).max(52).optional(),
  });

export const ListRecentPayPeriodsForReportsResponseSchema: z.ZodType<ListRecentPayPeriodsForReportsResponse> =
  z.object({
    items: z.array(PayPeriodDtoSchema),
  });

